import { createPage } from '../../shared/create-page'

// ============================================
// PÁGINAS DO MÓDULO AUTH (públicas / não autenticadas)
// ============================================

export const CbUnicoSuccessPage = createPage(
  () => import('@pages/auth/static/cb-unico-success-page')
)

export const FirstAccessPage = createPage(
  () => import('@pages/auth/static/first-access/first-access-page')
)

export const FirstAccessCpfPage = createPage(
  () => import('@pages/auth/static/first-access/cpf/first-access-cpf-page')
)

export const AppRedirectPage = createPage(
  () => import('@pages/auth/app-redirect/app-redirect-page')
)

export const SkillExplorerCatalogPage = createPage(
  () => import('@pages/auth/skill-explorer-catalog/skill-explorer-catalog')
)

export const LoginPage = createPage(() => import('@pages/auth/login'))

export const LogoutPage = createPage(() => import('@pages/auth/logout'))

export const ForgotPasswordPage = createPage(() => import('@pages/auth/forgot-password'))

export const ResendAccessPage = createPage(() => import('@pages/auth/resend-access'))

export const ResetPasswordPage = createPage(() => import('@pages/auth/reset-password'))

export const LoginFirstAccessPage = createPage(
  () => import('@/presentation/pages/auth/login-first-access')
)
